export default {"src":"/_next/static/media/flash.3ced6aea.svg","height":100,"width":100,"blurWidth":0,"blurHeight":0};